import ErrorPage from '@innovyze/stylovyze/lib/components/ErrorPage';
import Nav from '@innovyze/stylovyze/lib/components/Nav';
import { Redirect, Route, Switch } from 'react-router-dom';
import NotFoundPage from '@innovyze/stylovyze/lib/components/NotFoundPage';
import { AUTHENTICATION_URL_PARAMS } from '@innovyze/stylovyze/lib/types/authenticationContext.types';
import ScrollToTop from '@innovyze/stylovyze/lib/utils/ScrollToTop';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useSelector } from 'react-redux';
import { RenderComponentOrLoading } from '../../components';
import NoTenantCard from '../../components/ExpiredTenantDialog/NoTenantCard';
import useGetOrgList from '../../hooks/useGetOrgList';
import { selectRegionPickerStatus } from '../../selectors';
import { Page as PageStyled } from './Pages.styles';
import { calculateIsReadyFromStatus } from '../../utils/reducers.utils';
import { useConsumeWeaveTheme } from '../ApplicationWrapper/theme/WeaveContext/WeaveContext';
export function NoTenantRouter() {
    const regionPickerStatus = useSelector(selectRegionPickerStatus);
    const regionPickerInitialized = calculateIsReadyFromStatus(regionPickerStatus);
    // states from hooks (logic)
    const orgList = useGetOrgList();
    const hasATenant = orgList.length > 0;
    return (React.createElement(RenderComponentOrLoading, { loading: !regionPickerInitialized }, hasATenant ? React.createElement(Redirect, { to: "/" }) : React.createElement(NoTenantCard, null)));
}
export function Pages({ pages, showSideNav = true, exact = true, }) {
    const { resolvedRoles, isWeaveTheme } = useConsumeWeaveTheme();
    const backgroundColor = isWeaveTheme && resolvedRoles['colorScheme.surface.level250'];
    const textColor = isWeaveTheme && resolvedRoles['colorScheme.text.default'];
    return (React.createElement(React.Fragment, null,
        showSideNav && React.createElement(Nav, { pages: pages }),
        React.createElement(PageStyled, { id: "main", backgroundColor: backgroundColor, color: textColor },
            React.createElement(ErrorBoundary, { FallbackComponent: ErrorPage },
                React.createElement(Switch, null,
                    React.createElement(Route, { path: '/no-tenant', exact: true },
                        React.createElement(NoTenantRouter, null)),
                    pages.map(({ path, to, render }, i) => (React.createElement(Route, { key: i, exact: exact, path: path ?? to, render: ({ location }) => {
                            const elementId = location.hash
                                ? location.hash.replace('#', '')
                                : 'main';
                            return (React.createElement(React.Fragment, null,
                                React.createElement(ScrollToTop, { elementId: elementId, hashElement: !!location.hash }),
                                render));
                        } }))),
                    React.createElement(Redirect, { from: AUTHENTICATION_URL_PARAMS.AUTH0, to: "/" }),
                    React.createElement(Redirect, { from: AUTHENTICATION_URL_PARAMS.PICKER, to: "/" }),
                    React.createElement(Redirect, { from: AUTHENTICATION_URL_PARAMS.AUTODESK, to: "/" }),
                    React.createElement(Redirect, { from: AUTHENTICATION_URL_PARAMS.REGION_PICKER, to: "/" }),
                    React.createElement(Route, { path: "*" },
                        React.createElement(NotFoundPage, null)))))));
}
export default Pages;
